const {createProxyMiddleware} = require('http-proxy-middleware');

const host = {
  beta: 'support-beta1.eniot.io',
  ppe: 'support-ppe1.eniot.io',
  pdc: 'support-pdc1.eniot.io',
  cn5: 'support-cn5.envisioniot.com'
}.beta;

const baseOptions = {
  target: `https://${host}`,
  logLevel: 'debug',
  secure: false,
  changeOrigin: true,
  cookiePathRewrite: '/',
  cookieDomainRewrite: {
    '*': host
  },
  cookie: {
    httpOnly: false
  }
};

module.exports = function(app) {
  app.use('/comment/comment', createProxyMiddleware({...baseOptions}));
  app.use('/docs/api/v2/globalSearch/', createProxyMiddleware({...baseOptions}));
};

module.exports.host = host;
